/**
 * 站点元信息与内容类型。
 *
 * `site.json` 是**路由与站点元信息的唯一事实来源**：页面标题、描述、sitemap 权重、
 * 动态文章的 slug 与日期都写在那里。之所以用 JSON 而不是 TS，是为了让
 * `scripts/generate-sitemap.mjs` 能直接用 Node 读同一份数据，不必先编译 TypeScript。
 */
import siteJson from './site.json';

export interface RouteMeta {
  path: string;
  label: string;
  changefreq: 'always' | 'hourly' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'never';
  priority: number;
  title: string;
  description: string;
}

export interface NewsMeta {
  slug: string;
  date: string;
  title: string;
  excerpt: string;
  tags: string[];
}

export interface SiteConfig {
  url: string;
  locale: string;
  platformUrl: string;
  /** 统一控制台。承载账号、组织、接入应用与操作记录，也是全站唯一的登录入口。 */
  consoleUrl: string;
  pages: RouteMeta[];
  news: NewsMeta[];
}

export const SITE = siteJson as SiteConfig;

export const ROUTES: readonly RouteMeta[] = SITE.pages;

export const NEWS_META: readonly NewsMeta[] = [...SITE.news].sort((a, b) =>
  a.date < b.date ? 1 : a.date > b.date ? -1 : 0,
);

export function routeMeta(path: string): RouteMeta | undefined {
  return ROUTES.find((route) => route.path === path);
}

export function newsMeta(slug: string): NewsMeta | undefined {
  return NEWS_META.find((item) => item.slug === slug);
}

/** 品牌与联系方式，页面与页脚统一从这里取，避免文案分散。 */
export const BRAND = {
  /** 注册商标申请中，全站只使用 ™，禁止 ®。 */
  name: 'Havorix',
  mark: 'Havorix™',
  markNote: 'Havorix™ 商标注册申请中。',
  logline: '低空经济运营监管平台',
  email: 'contact@havorix.cn',
  github: 'https://github.com/Havorix-Aero',
  githubLabel: 'github.com/Havorix-Aero',
  copyrightFrom: 2025,
} as const;
